import { render, staticRenderFns } from "./certificate-form-submit-button.vue?vue&type=template&id=4d852bae&scoped=true"
import script from "./certificate-form-submit-button.vue?vue&type=script&lang=js"
export * from "./certificate-form-submit-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d852bae",
  null
  
)

export default component.exports